import type { AmenityBooking } from "../types/AmenityBooking";
import type { AuditTrail } from "../types/AuditTrail";
import type { Booking } from "../types/Booking";
import type { Location } from "../types/Location";
import type { Member } from "../types/Member";
import type { Organisation } from "../types/Organisation";
import type { Room } from "../types/Room";
import type { SystemNotification } from "../types/SystemNotification";
import type { Comment } from "@/types/Comment";
import type { Conversation, Message } from "@/types/Message";

export interface DatabaseSchema {
  auditTrail: AuditTrail[];
  amenityBookings: AmenityBooking[];
  locations: Location[];
  rooms: Room[];
  bookings: Booking[];
  members: Member[];
  systemNotifications: SystemNotification[];
  organisations: Organisation[];
  comments: Comment[];
  messages: Message[];
  conversations: Conversation[];
}

export const defaultDatabase: DatabaseSchema = {
  auditTrail: [],
  amenityBookings: [],
  locations: [],
  rooms: [],
  bookings: [],
  members: [],
  systemNotifications: [],
  organisations: [],
  comments: [],
  messages: [],
  conversations: [],
};
